import { useMemo } from 'react';
import { useDocuments } from '@/entities/document/hooks/use-documents';
import { isLowStock } from '@/entities/item/helpers/is-low-stock';
import { useItems } from '@/entities/item/hooks/use-items';
import { compareShopping } from '@/entities/shopping-item/helpers/compare-shopping';
import { shoppingTotals } from '@/entities/shopping-item/helpers/shopping-totals';
import { useShoppingItems } from '@/entities/shopping-item/hooks/use-shopping-items';
import { compareTasks } from '@/entities/task/helpers/compare-tasks';
import { isOpenTask } from '@/entities/task/helpers/is-open-task';
import { useTasks } from '@/entities/task/hooks/use-tasks';
import { attentionRows } from '../helpers/attention-rows';

export function useDashboard() {
  const items = useItems();
  const shopping = useShoppingItems();
  const tasks = useTasks();
  const docs = useDocuments();
  return useMemo(
    function summarise() {
      const attention = attentionRows({
        items: items ?? [],
        docs: docs ?? [],
        tasks: tasks ?? [],
        shopping: shopping ?? [],
      });
      return {
        loading: !items || !shopping || !tasks || !docs,
        items,
        docs,
        attention,
        overdue: attention.filter((row) => row.due.urgency === 'overdue').length,
        low: (items ?? []).filter((view) => isLowStock(view.data)),
        openTasks: (tasks ?? [])
          .filter((view) => isOpenTask(view.data))
          .sort((a, b) => compareTasks(a.data, b.data)),
        toBuy: (shopping ?? [])
          .filter((view) => view.data.status === 'pending')
          .sort((a, b) => compareShopping(a.data, b.data)),
        totals: shoppingTotals(shopping ?? []),
        tasksLoaded: tasks !== undefined,
        shoppingLoaded: shopping !== undefined,
      };
    },
    [items, shopping, tasks, docs],
  );
}
